import { V2_GetTimeCodeStartToSecondFromAsset,V2_GetOneFrameDuration } from "./timecodev2";

function getConfigurationVersion()
{
    return "1.01";
}

export function configurations_getDefaultParams(num=25, den=1, dropframe=0)
{
    var conf =  {   

          teletext: false, 
          teletext2: false,
          
          boxing: false,


          
          
          doubleHeight: true, // true ou false
          numberOfLines: 2, // 1 … subtitleNumberOfLines
          defaultAlignment: 2, // « center », « left », « right », “manual”,
          fontName: 'Arial', // « nom de la police à utiliser »
          fontItalic: false,
          fontColor: "#FFFFFF",
          maxLength: 37, // nombre maximum de caractères (espaces compris) par ligne
          maxLengthColor: 35, // nombre max caractères si ligne not blanc
          startLine: 19, // 1… displayNumberOfLines,

          lisibilityMode: 0,


          lisibilityIdeal: 14,
          lisibility: 16,
          lisibilityMax: 19,

          lisibilityIdealMM: 140,
          lisibilityMM: 170,
          lisibilityMaxMM: 220,


          // Lisibilité en cas de génération automatique

          lisibilityIdealCST: 14,
          lisibilityCST: 16,
          lisibilityMaxCST: 19,

          lisibilityIdealCSTMM: 140,
          lisibilityCSTMM: 170,
          lisibilityMaxCSTMM: 220,


          // calcul sur la lisibilité
          speechRateMode: 1,
          speechRate: 18,
          speechRateMM: 190,


          // optimisation en calcul
          stickEndSentence: (12 * 40) /1000, // si proche CP
          stickInterSubtitle: (12*40) /1000,
          stickBrokenSentence: (30 * 40) /1000, // si phrase découpée

          // timing
          interst : (5 * 40) /1000,
          beforecp : (2 * 40) / 1000,
          aftercp: (3 * 40) / 1000,
          min: (19 * 40) / 1000,
          max: (100 * 40) / 1000,

          toleranceIn: (2 * 40) / 1000,
          
          // La meme chose en images

          i_stickEndSentence: 12, // si proche CP
          i_stickInterSubtitle: 12,
          i_stickBrokenSentence: 30, // si phrase découpée

          // timing
          i_interst : (5 * 40) /1000,
          i_beforecp : (2 * 40) / 1000,
          i_aftercp: (3 * 40) / 1000,
          i_min: (19 * 40) / 1000,
          i_max: (100 * 40) / 1000,

          i_toleranceIn: (2 * 40) / 1000,

          
          verticalPos: 22,
          
          usecplist: false,
          displayNumberOfLines: 23,
          cplist: [],

          num:num,
          den:den,
          dropframe:dropframe,


          createFirstSubtitle: true,
          defaultColor: "#FFFFFF",
          usePreviousColor: true,

        }

        return configurations_framestotime( conf, num,den,dropframe)

}

export function configurations_framestotime(conf, num=25, den=1, dropframe=0)
{
    const frameduration = V2_GetOneFrameDuration(num, den)

    

    if (!("version" in conf) || (conf.version !== getConfigurationVersion()))
    {
        // ici cest une ancienne configuration, on fait l'inverse

        conf.i_stickEndSentence = Math.round(conf.stickEndSentence / frameduration);
        conf.i_stickInterSubtitle = Math.round(conf.stickInterSubtitle / frameduration);
        conf.i_stickBrokenSentence = Math.round(conf.stickBrokenSentence / frameduration);
        
        conf.i_interst = Math.round(conf.interst / frameduration);
        conf.i_beforecp = Math.round(conf.beforecp / frameduration);
        conf.i_aftercp = Math.round(conf.aftercp / frameduration);
        conf.i_min = Math.round(conf.min / frameduration);
        conf.i_max = Math.round(conf.max / frameduration);

        conf.i_toleranceIn = Math.round(conf.toleranceIn / frameduration);

    }

    conf.num = num;
    conf.den = den;
    conf.dropframe = dropframe;

    conf.stickEndSentence = conf.i_stickEndSentence * frameduration;
    conf.stickInterSubtitle = conf.i_stickInterSubtitle * frameduration;
    conf.stickBrokenSentence = conf.i_stickBrokenSentence * frameduration;

    conf.interst = conf.i_interst * frameduration;
    conf.beforecp = (conf.i_beforecp) * frameduration;
    
    conf.aftercp = conf.i_aftercp * frameduration;
    conf.min = conf.i_min * frameduration;
    conf.max = conf.i_max * frameduration;

    conf.toleranceIn = conf.i_toleranceIn * frameduration;


    conf.version= getConfigurationVersion();

    
    
    return conf;
}


export function configurations_getDefaultTimeLineParams()
{
    return  {
            displayCpArea: true,
            magnetism: 4,
            displayFrame: true,

            trtrackaudio: true,
            trsmalltrackaudio: false,
            trtrackcp:true,
            trsmalltrackcp: false,

            troriginaltr:true,
            trcorrectedtr: true,

            sttrackaudio: true,
            stsmalltrackaudio: false,
            sttrackcp:true,
            stsmalltrackcp: false,

            storiginaltr:true,
            stcorrectedtr: true,

            storiginalst: true,
        }

}

export function configurations_getDefaultPlayerParams()
{
        return {
            background: false,
            backgroundtransparency: 80,
            displaytc: true,
            displaytcms: false,
            dontscale: true,
            displayhposition: true,
            displayhposition2: true,
            useconfintervalvalue: true,
            playerintervalvalue: 20,
        };

}

export function configurations_getDefaultAppParams_checkvalues(appparams)
{
    if (!("initialFontSize") in appparams.transcription)
        appparams.transcription.initialFontSize = 22;
    if (!("disablePopup") in appparams.transcription)
        appparams.transcription.disablePopup = false;
    if (!("disablePopup") in appparams.subtitling)
        appparams.subtitling.disablePopup = false;
    return appparams;
}

export function configurations_getDefaultAppParams()
{
    return {
        transcription: {
            initialFontSize: 22, // taille de la police
            disablePopup: false,

        },
        subtitling: {
            displaySubToolsBar: true,
            displayWordsButtons: true,
            disablePopup: false,
        }
    }
}



export function configuration_createBlankSubtitle(timecodeAsset, subtitleParameters)
{

    var subtitle = {
        in: V2_GetTimeCodeStartToSecondFromAsset(timecodeAsset),
        out: V2_GetTimeCodeStartToSecondFromAsset(timecodeAsset) + subtitleParameters.min,

        lines:[
            {
                len:0,
                words:[],
                doubleHeight: subtitleParameters.doubleHeight,
                align: subtitleParameters.defaultAlignment,
            }
        ],
        id:0,
        len:0,
        mark:0,

    }
    return subtitle;
}
